import request from '../config/axiosConfig';
import { GET_LIST_CATEGORIES, GET_ALL_CATEGORIES, GET_CATEGORY_INFO, CREATE_CATEGORY, UPDATE_CATEGORY, DELETE_CATEGORY } from '../constants/categoryApiEndPoint';

export const getCategories = async (params) => {
  return (
    await request({
      url: GET_LIST_CATEGORIES,
      method: 'GET',
      params,
    })
  )?.data;
};

export const getAllCategories = async () => {
  return (
    await request({
      url: GET_ALL_CATEGORIES,
      method: 'GET',
    })
  )?.data;
};

export const getCategoryInfo = async (id) => {
  return (
    await request({
      url: GET_CATEGORY_INFO,
      method: 'GET',
      params: { id },
    })
  )?.data;
};

export const createCategory = async (data) => {
  return (
    await request({
      url: CREATE_CATEGORY,
      method: 'POST',
      data,
    })
  )?.data;
};

export const updateCategory = async (id, data) => {
  return (
    await request({
      url: UPDATE_CATEGORY,
      method: 'POST',
      params: { id },
      data,
    })
  )?.data;
};

export const deleteCategory = async (id) => {
  return (
    await request({
      url: DELETE_CATEGORY,
      method: 'DELETE',
      params: { id },
    })
  )?.data;
};
